import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* Types & Action Creators */
const { Types, Creators } = createActions({
  // Requests actions
  requestStudentComments: [],
  requestLessonComments: ['courseId', 'lessonId'],
  requestStoreComment: ['courseId', 'lessonId', 'parentId', 'description'],
  requestUpdateComment: ['courseId', 'lessonId', 'commentId', 'description'],
  requestRemoveComment: ['courseId', 'lessonId', 'commentId'],
  // Handle store actions
  setStudentComments: ['comments'],
  setStudentCommentsFailure: ['errorData'],
  updateStudentComments: ['comments'],
  removeStudentComment: ['commentId'],
});
export const CommentsTypes = Types;
export default Creators;

/* Initial State */
export const INITIAL_STATE = Immutable({
  studentComments: {
    list: {},
    error: null,
    loaded: false,
  },
});

const setStudentComments = (state = INITIAL_STATE, { comments }) =>
  Immutable.updateIn(state, ['studentComments'], studentComments =>
    Immutable.merge(studentComments, {
      list: comments,
      loaded: true,
      error: null,
    }),
  );

const setStudentCommentsFailure = (state = INITIAL_STATE, { errorData }) =>
  Immutable.setIn(state, ['studentComments', 'error'], errorData);

const updateStudentComments = (state = INITIAL_STATE, { comments }) =>
  Immutable.updateIn(state, ['studentComments', 'list'], list =>
    Immutable.merge(list, comments),
  );

const removeStudentComment = (state = INITIAL_STATE, { commentId }) =>
  Immutable.updateIn(state, ['studentComments', 'list'], list =>
    Immutable.without(list, commentId),
  );

/* Reducers to types */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_STUDENT_COMMENTS]: setStudentComments,
  [Types.SET_STUDENT_COMMENTS_FAILURE]: setStudentCommentsFailure,
  [Types.UPDATE_STUDENT_COMMENTS]: updateStudentComments,
  [Types.REMOVE_STUDENT_COMMENT]: removeStudentComment,
});
